
import Vue from "vue";
import MemberTag from "./MemberTag.vue";
import CardData from "../models/CardData";

type Prop<T> = () => T;

interface IData {
  opened: boolean;
}
export default Vue.extend({
  name: "Card",
  components: {
    MemberTag,
  },
  props: {
    card: Object as Prop<CardData>,
  },
  data(): IData {
    return {
      opened: this.card.opened,
    };
  },
  methods: {
    click() {
      this.$emit("onSelect", this.card.id, false);
    },
    doubleClick() {
      this.$emit("onSelect", this.card.id, true);
    },
  },
});

